export function groupOptions(options) {
    const groupedOptions = [];
    const unGroupedOptions = [];
    const optionGroups = {};
    options.map((item) => {
        if (item.group) {
            if (optionGroups[item.group]) {
                optionGroups[item.group].push(item);
            }
            else {
                optionGroups[item.group] = [item];
            }
        }
        else {
            unGroupedOptions.push(item);
        }
    });
    if (unGroupedOptions.length) {
        groupedOptions.push({
            group: null,
            options: unGroupedOptions,
        });
    }
    Object.keys(optionGroups).forEach((groupName) => {
        groupedOptions.push({
            group: groupName,
            options: optionGroups[groupName],
        });
    });
    return groupedOptions;
}
export function formatOptions(options) {
    if (typeof options[0] === 'string') {
        const selectOptions = options.map((item) => ({ content: item, value: item }));
        return [{ group: null, options: selectOptions }];
    }
    return groupOptions(options);
}
